import { company } from '../content/site';
import { Doorway } from './Icons';
import './Wordmark.css';

type Props = {
  /** `ink` for light backgrounds, `light` for the navy footer and hero. */
  tone?: 'ink' | 'light';
};

export function Wordmark({ tone = 'ink' }: Props) {
  const [first, second] = company.name.split(' ');

  return (
    <span className={`wordmark wordmark--${tone}`}>
      <Doorway className="wordmark__mark" aria-hidden />
      <span className="wordmark__text">
        <span className="wordmark__name">{first}</span>
        <span className="wordmark__suffix">{second}</span>
      </span>
    </span>
  );
}
